import { render, staticRenderFns } from "./crudPHPCallback.vue?vue&type=template&id=a1415dfe&"
import script from "./crudPHPCallback.vue?vue&type=script&lang=js&"
export * from "./crudPHPCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports